import { Component, AfterViewInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import * as L from 'leaflet';

interface MapCoords {
  ng: L.LatLngExpression;
  de: L.LatLngExpression;
}
const svgIcon = L.icon({
  iconUrl: 'assets/svgs/icons/location-red.png',
  iconSize: [36.75, 52.5], // size of the icon
  iconAnchor: [16, 32], // point of the icon which corresponds to marker position
  popupAnchor: [0, -32], // where popup opens relative to the icon
});

const coords: MapCoords = {
  ng: [6.459009726068961, 7.516506924483042],
  de: [53.59646935156593, 10.050735412721338],
};
@Component({
  selector: 'app-atrizult-map',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './atrizult-map.component.html',
  styleUrl: './atrizult-map.component.scss',
})
export class AtrizultMapComponent implements AfterViewInit {
  mapCoords = coords.ng;

  private map!: L.Map;
  private marker!: L.Marker;

  ngAfterViewInit(): void {
    this.map = L.map('atrizult-map').setView(this.mapCoords, 12);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    this.marker = L.marker(this.mapCoords, { icon: svgIcon })
      .addTo(this.map)
      .bindPopup('Our Office');

    setTimeout(() => this.map.invalidateSize(), 200);
  }

  onClickAddress(lang: 'ng' | 'de') {
    this.mapCoords = coords[lang];

    // 🔥 UPDATE LEAFLET MANUALLY
    this.map.setView(this.mapCoords, 12);
    this.marker.setLatLng(this.mapCoords);
  }
}

